import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Home from "./components/pages/home";
import { Provider } from "./Context";

const App = () => {

    return (
        <Provider>
            <Switch>
                <Route exact path="/">
                    <Home/>
                </Route>
                <Route path="*" component={Home} />
            </Switch>
        </Provider>
    );
};

export default App;